// apps/ecommerce/src/components/ai-chat/chat-panel.tsx
import { ChatContainer } from './chat-container';

interface ChatPanelProps {
  connectionId: string;
  isOpen: boolean;
  onClose: () => void;
}

export function ChatPanel({ connectionId, isOpen, onClose }: ChatPanelProps) {
  return (
    <>
      {/* Desktop: inline panel */}
      <aside
        className={[
          'hidden md:flex flex-col',
          'border-l border-base-300 bg-base-200',
          'transition-all duration-300 ease-in-out overflow-hidden',
          isOpen ? 'w-[480px]' : 'w-0',
        ].join(' ')}
      >
        {isOpen && <ChatContainer connectionId={connectionId} />}
      </aside>

      {/* Mobile: drawer overlay */}
      <div className={['md:hidden drawer drawer-end', isOpen && 'drawer-open'].filter(Boolean).join(' ')}>
        <input
          type="checkbox"
          className="drawer-toggle"
          checked={isOpen}
          onChange={onClose}
        />
        <div className="drawer-side z-50">
          <label className="drawer-overlay" onClick={onClose}></label>
          <div className="bg-base-200 min-h-full w-full max-w-md">
            {isOpen && <ChatContainer connectionId={connectionId} />}
          </div>
        </div>
      </div>
    </>
  );
}
